import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';

import { GetTagListService } from './api-services/get-tag-list.service';
import { GetTagGroupListService } from './api-services/get-tag-group-list.service';
import { RegistTagGroupListService } from './api-services/regist-tag-group-list.service';
import { RegistTagListService } from './api-services/regist-tag-list.service';
import { KYMW4601Module } from '../kymw4601/kymw4601.module';
import { KYMW4602Module } from '../kymw4602/kymw4602.module';

import { KYMW4600Component } from './kymw4600.component';

/**
 * タグ管理画面 モジュール設定クラス
 *
 * @export KYMW4600Module
 * @class KYMW4600Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjGridFilterModule,
    KYMW4601Module,
    KYMW4602Module,
  ],
  declarations: [KYMW4600Component],
  providers: [
    GetTagListService,
    GetTagGroupListService,
    RegistTagGroupListService,
    RegistTagListService,
  ],
})
export class KYMW4600Module {}
